module.exports = {"BOOL (布尔型)":"BOOL","SBYTE (8位有符号型)":"SBYTE","BYTE (8位无符号型)":"BYTE","INT (16位有符号型)":"INT","WORD (16位无符号型)":"WORD","DINT (32位有符号型)":"DINT","DWORD (32位无符号型)":"DWORD","REAL (32位浮点型)":"REAL"}


//////////////////
// WEBPACK FOOTER
// ./src/config/type.json
// module id = 2jAJ
// module chunks = 1